import React from 'react';
import { Container } from '@mui/material';
import Filter from './Filter';
import ForecastTable from './ForecastTable';

const ForecastManager = () => {
  return (
    <Container
      maxWidth={false}
      sx={{
        display: 'flex',
        gap: 2,
        padding: 2,
        flexDirection: 'column',
        minHeight: 'calc(100vh - 64px)', // 64px is the height of the app header
      }}
    >
      <Filter />
      <ForecastTable />
    </Container>
  );
};

export default ForecastManager;
